import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type MostActiveCpt4Action =
  | ActionType<typeof actions.getMostActiveCpt4Request>
  | ActionType<typeof actions.getMostActiveCpt4Success>
  | ActionType<typeof actions.getMostActiveCpt4Fail>
  | ActionType<typeof actions.createMostActiveCpt4Request>
  | ActionType<typeof actions.createMostActiveCpt4Success>
  | ActionType<typeof actions.createMostActiveCpt4Fail>
  | ActionType<typeof actions.updateMostActiveCpt4Request>
  | ActionType<typeof actions.updateMostActiveCpt4Success>
  | ActionType<typeof actions.updateMostActiveCpt4Fail>
  | ActionType<typeof actions.deleteMostActiveCpt4Request>
  | ActionType<typeof actions.deleteMostActiveCpt4Success>
  | ActionType<typeof actions.deleteMostActiveCpt4Fail>

  export interface MostActiveCpt4 {
    contractGroup: string,
    cpt4Code: string,
    cpt4Description: string,
    // created: string,
    id: number,
    locationId: number,
    locationLongName: string,
    locationShortName: string,
    // manual: true,
    // modified: string,
    n: number,
    period: number,
    serviceArea?: string | number
  }

  export interface MostActiveCpt4State {
    isFetching: boolean
    data: {
      content: Array<MostActiveCpt4>
      size: number,
      totalPages: number,
      number: number
    },
    errors: {
        fetchingError: boolean;
        creatingError: boolean;
        updatingError: boolean;
        deletingError: boolean;
    }
  }

  export enum MostActiveCpt4Types {
    FETCH_MOST_ACTIVE_CPT4_REQUEST = '@@references/FETCH_MOST_ACTIVE_CPT4_REQUEST',
    FETCH_MOST_ACTIVE_CPT4_SUCCESS = '@@references/FETCH_MOST_ACTIVE_CPT4_SUCCESS',
    FETCH_MOST_ACTIVE_CPT4_FAIL = '@@references/FETCH_MOST_ACTIVE_CPT4_FAIL',
    CREATE_MOST_ACTIVE_CPT4_REQUEST = '@@references/CREATE_MOST_ACTIVE_CPT4_REQUEST',
    CREATE_MOST_ACTIVE_CPT4_SUCCESS = '@@references/CREATE_MOST_ACTIVE_CPT4_SUCCESS',
    CREATE_MOST_ACTIVE_CPT4_FAIL = '@@references/CREATE_MOST_ACTIVE_CPT4_FAIL',
    UPDATE_MOST_ACTIVE_CPT4_REQUEST = '@@references/UPDATE_MOST_ACTIVE_CPT4_REQUEST',
    UPDATE_MOST_ACTIVE_CPT4_SUCCESS = '@@references/UPDATE_MOST_ACTIVE_CPT4_SUCCESS',
    UPDATE_MOST_ACTIVE_CPT4_FAIL = '@@references/UPDATE_MOST_ACTIVE_CPT4_FAIL',
    DELETE_MOST_ACTIVE_CPT4_REQUEST = '@@references/DELETE_MOST_ACTIVE_CPT4_REQUEST',
    DELETE_MOST_ACTIVE_CPT4_SUCCESS = '@@references/DELETE_MOST_ACTIVE_CPT4_SUCCESS',
    DELETE_MOST_ACTIVE_CPT4_FAIL = '@@references/DELETE_MOST_ACTIVE_CPT4_FAIL'
  }